import { render, staticRenderFns } from "./FlexButton.vue?vue&type=template&id=6fda2e25&scoped=true&"
import script from "./FlexButton.vue?vue&type=script&lang=ts&"
export * from "./FlexButton.vue?vue&type=script&lang=ts&"
import style0 from "./FlexButton.vue?vue&type=style&index=0&id=6fda2e25&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda2e25",
  null
  
)

export default component.exports